import "core-js/stable";
import * as Sentry from "@sentry/browser";

//---- I18n IMPORT AND INIT ----
import { I18n } from "i18n-js";
import translations from "../../../vendor/assets/translations.json";
export const i18n = new I18n();
i18n.store(translations);
i18n.enableFallback = pp.env != "development";
window.I18n = i18n;

import { Application } from "@hotwired/stimulus";
import fillTokenLobbyController from "./controllers/fill_token_lobby_controller";
import activities from "./vanilla/activities";
import activityFeedHelpers from "./vanilla/activity_feed_helpers";
import analysis from "./vanilla/analysis.js";
import approvalRatings from "./vanilla/approval-ratings.js";
import articleTemplateGaps from "./vanilla/backend/article_template_gaps.js";
//---- VANILLA BACKEND JS IMPORTS ----
import backend from "./vanilla/backend/backend.js";
import DrawflowWrapper from "./vanilla/backend/drawflow_wrapper.js";
import formHelpers from "./vanilla//backend/form_helpers.js";
import gameCloning from "./vanilla/backend/game-cloning.js";
import measureAffordabilityConditions from "./vanilla/backend/measure_affordability_conditions.js";
import modifierApplicabilityConditions from "./vanilla/backend/modifier_applicability_conditions.js";
import propertiesSandbox from "./vanilla/backend/properties_sandbox.js";
import userManager from "./vanilla/backend/user_manager.js";
import { initBackendFilters } from "./vanilla/backend_filters";
//---- VANILLA JS IMPORTS ----
import CharsUtil from "./vanilla/chars_util";
import chat from "./vanilla/chat.js";
import comment from "./vanilla/comment.js";
import WordingSearch from "./vanilla/customizable_wording_search.js";
import Doughnut from "./vanilla/doughnut-chart.js";
import filters from "./vanilla/filters.js";
import gameTokenLobby from "./vanilla/game_token_lobby";
import gameState from "./vanilla/global/game_state.js";
import global from "./vanilla/global/global.js";
import { fayeLog, log } from "./vanilla/global/log.js";
import navigation from "./vanilla/global/navigation";
import notifications from "./vanilla/global/notifications.js";
import pageChangeConfirm from "./vanilla/global/page_change_confirm.js";
import stickyButtons from "./vanilla/global/sticky_buttons";
import disableIosTextFieldZoom from "./vanilla/iphone_zoom_fix.js";
import dotDotDot from "./vanilla/jquery.dotdotdot-wrapper.js";
import pad from "./vanilla/jquery.plugin-pad.js";
import mapInformation from "./vanilla/map_information.js";
import measures from "./vanilla/measures.js";
import myGroup from "./vanilla/my_group.js";
import phaseManager from "./vanilla/phase_manager.js";
import plenary from "./vanilla/plenary.js";
import projector from "./vanilla/projector";
import quiz from "./vanilla/quiz";
import FuzzySearch from "./vanilla/simple_fuzzy_search";
import specificViewHelpers from "./vanilla/specific_view_helpers";
import Tabifier from "./vanilla/tabifier.js";
import tinyMCE from "./vanilla/tiny_mce";
import videos from "./vanilla/videos";
import viewHelpers from "./vanilla/view_helpers";
import waitingRoom from "./vanilla/waiting_room";

import "./vanilla/tinymce_plugins/kb_module_link.js";
import "./vanilla/tinymce_plugins/typekit.js";
import "./vanilla/tinymce_plugins/quizlink.js";
import "./vue.js";

globalThis.sentry = Sentry.init({
	integrations: [Sentry.browserTracingIntegration()],
	dsn: pp.sentryDsn,
	tracePropagationTargets: [],
	environment: pp.env,
	release: pp.releaseName,
});

Sentry.setTags({
	actor: pp.currentActorId,
	game: pp.currentGameId,
});
// @ts-expect-error
Sentry.setUser({
	id: pp.currentUserId,
	original: pp.originalUserId,
});

//---- VANILLA ASSIGNMENTS ----
pp.viewHelpers = viewHelpers;
pp.activities = activities;
pp.activityFeedHelpers = activityFeedHelpers;
pp.Tabifier = Tabifier;
pp.DrawflowWrapper = DrawflowWrapper;

// Merge existing (or empty) object with the functions from this file
pp = Object.assign({}, pp, specificViewHelpers);
pp.tinyMCE = tinyMCE;
pp.gameTokenLobby = gameTokenLobby;
pp.waitingRoom = waitingRoom;
window.CharsUtil = CharsUtil;
window.Doughnut = Doughnut;
pp.projector = projector;
pp.quiz = quiz;
pp.videos = videos;
pp.filters = filters;
pp.measures = measures;
pp.analysis = analysis;
pp.phaseManager = phaseManager;

pp.approvalRatings = approvalRatings;
pp.chat = chat;
pp.comment = comment;
pp.dotDotDot = dotDotDot;
pp.mapInformation = mapInformation;
pp.myGroup = myGroup;
pp.plenary = plenary;
pp.gameState = gameState;
pp.global = global;
pp.log = log;
pp.fayeLog = fayeLog;
pp.navigation = navigation;
pp.stickyButtons = stickyButtons;
pp.notifications = notifications;
pp.pageChangeConfirm = pageChangeConfirm;
window.Pad = pad;

// Backend
pp.backend = {
	...backend,
	formHelpers: {
		...formHelpers,
		measureAffordabilityConditions,
		modifierApplicabilityConditions,
		articleTemplateGaps,
	},
	gameCloning,
	propertiesSandbox,
	userManager,
};
window.WordingSearch = WordingSearch;
window.FuzzySearch = FuzzySearch;
pp.backend.initBackendFilters = initBackendFilters;

const stimulus = Application.start();
stimulus.register("fill-token-lobby", fillTokenLobbyController);

if (bowser.ios) {
	disableIosTextFieldZoom();
}
